import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onRetry }) => {
  const errorTitle = 'Search Failed';
  const commonIssuesTitle = 'Common Issues:';
  const commonIssues = [
    'BigQuery service may be temporarily unavailable',
    'Network connectivity issues',
    'Invalid temperature or preference values',
    'Server overload during peak usage'
  ];
  const retryButtonText = 'Try Again';

  return (
    <div className="card">
      <div className="flex items-start space-x-3">
        <AlertCircle className="h-6 w-6 text-red-500 flex-shrink-0 mt-1" />
        <div className="flex-1">
          <h3 className="text-lg font-medium text-red-800 mb-2">
            {errorTitle}
          </h3>
          <p className="text-red-700 mb-4">
            {message}
          </p>
          
          <div className="bg-red-50 rounded-lg p-3 mb-4">
            <h4 className="text-sm font-medium text-red-800 mb-2">{commonIssuesTitle}</h4>
            <ul className="text-sm text-red-700 space-y-1">
              {commonIssues.map((issue, index) => (
                <li key={index}>• {issue}</li>
              ))}
            </ul>
          </div>
          
          {onRetry && (
            <button
              onClick={onRetry}
              className="btn-primary flex items-center space-x-2"
            >
              <RefreshCw className="h-4 w-4" />
              <span>{retryButtonText}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
